"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagesToJSON = exports.MessagesFromJSONTyped = exports.MessagesFromJSON = void 0;
var _1 = require("./");
function MessagesFromJSON(json) {
    return MessagesFromJSONTyped(json, false);
}
exports.MessagesFromJSON = MessagesFromJSON;
function MessagesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'elements': (json['elements'].map(_1.MessageFromJSON)),
        'flags': json['flags'],
    };
}
exports.MessagesFromJSONTyped = MessagesFromJSONTyped;
function MessagesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'elements': (value.elements.map(_1.MessageToJSON)),
        'flags': value.flags,
    };
}
exports.MessagesToJSON = MessagesToJSON;
//# sourceMappingURL=Messages.js.map